import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { SessionDataService } from '@providers/session/session-data.service';
import { distinctUntilKeyChanged, filter, switchMap } from 'rxjs/operators';
import { ISession } from '@interfaces/session/session.interface';
import { CarriersService } from '@providers/carrier/carriers.service';
import { ICarrier } from '@interfaces/carrier/carrier.interface';

@Injectable({
  providedIn: 'root',
})
export class CurrentCarrierDataService {
  private _isOtherCarrierSelected: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  private _isCarrieHasDeals: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  private _isCarrieHasPlans: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  private _currentCarrier: BehaviorSubject<ICarrier> = new BehaviorSubject<ICarrier>(null);

  constructor(
    private sessionDataService: SessionDataService,
    private carriersService: CarriersService
  ) {}

  public get isOtherCarrierSelected(): BehaviorSubject<boolean> {
    return this._isOtherCarrierSelected;
  }

  public get isCarrieHasDeals(): BehaviorSubject<boolean> {
    return this._isCarrieHasDeals;
  }

  public get isCarrieHasPlans(): BehaviorSubject<boolean> {
    return this._isCarrieHasPlans;
  }

  public get currentCarrier(): BehaviorSubject<ICarrier> {
    return this._currentCarrier;
  }

  public static checkIfOtherCarrierSelected(carrier: ICarrier): boolean {
    return !Boolean(carrier.cr__has_deals) && !Boolean(carrier.cr__has_plans);
  }

  public init(): void {
    this.sessionDataService.$currentSession
      .pipe(
        filter((session: ISession) => Boolean(session?.se__carrier_id_cur)),
        distinctUntilKeyChanged('se__carrier_id_cur'),
        switchMap((session: ISession) => this.carriersService.getById(session.se__carrier_id_cur))
      )
      .subscribe((carrier: ICarrier) => {
        this.setIsOtherCarrierSelected(carrier);
        this.setIsCarrieHasDeals(carrier);
        this.setCarrieHasPlans(carrier);
        this.setCurrentCarrier(carrier);
      });
  }

  private setIsOtherCarrierSelected(carrier: ICarrier): void {
    const value: boolean = CurrentCarrierDataService.checkIfOtherCarrierSelected(carrier);
    this._isOtherCarrierSelected.next(value);
  }

  private setIsCarrieHasDeals(carrier: ICarrier): void {
    this._isCarrieHasDeals.next(Boolean(carrier.cr__has_deals));
  }

  private setCarrieHasPlans(carrier: ICarrier): void {
    this._isCarrieHasPlans.next(Boolean(carrier.cr__has_plans));
  }

  private setCurrentCarrier(carrier: ICarrier): void {
    this._currentCarrier.next(carrier);
  }
}
